export default () => ({
  ids: null,
});
